export default function downloadCsvContent(filename: string, text: string) {
  const BOM = '\uFEFF';
  const fullText = BOM + text;

  const blobObject = new Blob([fullText], {
    type: 'text/csv;charset=utf-8',
  });

  const anchor = document.createElement('a');
  anchor.download = filename;

  if (window.URL.createObjectURL) {
    // Modern browsers
    anchor.href = window.URL.createObjectURL(blobObject);
  } else {
    // Legacy fallback
    anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(fullText)}`;
  }

  // Skip clicking during Cypress tests
  if (!window.Cypress) {
    anchor.click();
  }
}
